

















































import Farty from '@/components/Farty.vue'
import Console from '@/components/Console.vue'
import GutHistory from '@/components/GutHistory.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'App',
  components: {
    Farty,
    Console,
    GutHistory
  }
})
export default class App extends Vue {
  showLog: boolean = false
  showGutLevels: boolean = false

  get fartyPanelBinding() {
    const binding = {}
    if (this['$vuetify'].breakpoint.smAndUp) {
      binding['order-xs1'] = false
    } else {
      binding['order-xs1'] = true
    }
    return binding
  }

  get consolePanelBinding() {
    const binding = {}
    if (this['$vuetify'].breakpoint.smAndUp) {
      binding['order-xs2'] = false
    } else {
      binding['order-xs2'] = true
    }
    return binding
  }

  get topLevelLayoutBinding() {
    const binding: { row: boolean; column: boolean } = {
      row: false,
      column: false
    }

    if (this['$vuetify'].breakpoint.smAndUp) {
      binding.row = true
    } else {
      binding.column = true
    }

    return binding
  }

  get version() {
    return process.env.PACKAGE_VERSION
  }

  toggleLogs() {
    this.showLog = !this.showLog
  }

  toggleGutLevels() {
    this.showGutLevels = !this.showGutLevels
  }

  openSource() {
    window.open('https://github.com/turbofoxwave/farty-vue', '_blank')
  }
}
